import { createFileRoute, Link } from "@tanstack/react-router";

import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";

const TITLE = "Your Consultation is Scheduled - RESTORE Hair";
const DESCRIPTION =
  "Your complimentary RESTORE Hair consultation is confirmed. Check your email for the appointment details.";
const CANONICAL_URL = "https://restorehair.com/contact-us/scheduling-confirmation/";

export const Route = createFileRoute("/contact-us/scheduling-confirmation")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { property: "og:url", content: CANONICAL_URL },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex, follow" },
    ],
    links: [{ rel: "canonical", href: CANONICAL_URL }],
  }),
  component: SchedulingConfirmationPage,
});

function SchedulingConfirmationPage() {
  return (
    <div className="min-h-screen bg-background font-sans">
      <Header />
      <main>
        <section
          style={{ backgroundColor: "#f5f5f5" }}
          className="px-4 pb-20 pt-16 md:pb-24 md:pt-[108px]"
        >
          <div className="mx-auto max-w-[900px] text-center">
            <h1
              className="font-bold text-black"
              style={{ fontSize: "clamp(30px, 4.4vw, 42px)", lineHeight: 1.14 }}
            >
              Your Consultation is Scheduled!
            </h1>
            <p
              className="mt-8"
              style={{ fontSize: "19px", lineHeight: "32px", color: "#6a6b6c" }}
            >
              Thank you for booking your complimentary consultation with RESTORE&reg;. A
              confirmation email with your appointment details is on its way to your inbox.
            </p>
            <p
              className="mt-6"
              style={{ fontSize: "16px", lineHeight: "28px", color: "#6a6b6c" }}
            >
              A client advisor will reach out beforehand if anything else is needed. In the
              meantime, take a look at real client results and answers to the most common
              questions.
            </p>
            <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
              <Link
                to="/results/"
                className="rounded bg-primary px-6 py-3 font-semibold text-primary-foreground"
              >
                See Client Results
              </Link>
              <Link
                to="/hair-loss-blog/"
                className="rounded border border-border px-6 py-3 font-semibold text-foreground"
              >
                Read Our Blog
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
